import { dayNumberInData, zeroArrayTemplate } from "../functions";
import type {
  CalcOptions,
  DaySettingsData,
  NumberMatrix,
} from "../algorithm.types";

type CalculateAvailabilityParams = {
  calcOptions: Pick<
    CalcOptions,
    | "noOfTechs"
    | "noOfTimeSlots"
    | "season"
    | "dayOfTheSeason"
    | "noOfDaysPerSeason"
  >;
  daySettingsData: DaySettingsData;
  sliderValues: Array<number>;
};

export default function calculateAvailability({
  calcOptions,
  daySettingsData,
  sliderValues,
}: CalculateAvailabilityParams): NumberMatrix {
  const {
    noOfTechs,
    noOfTimeSlots,
    season,
    dayOfTheSeason,
    noOfDaysPerSeason,
  } = calcOptions;
  const availData = zeroArrayTemplate(noOfTechs, noOfTimeSlots);

  for (let i = 0; i < noOfTechs; i++) {
    for (let j = 0; j < noOfTimeSlots; j++) {
      availData[i][j] =
        sliderValues[i] *
        daySettingsData[
          dayNumberInData(season, dayOfTheSeason, noOfDaysPerSeason)
        ][i + 1][j];
    }
  }

  return availData;
}
